import TableWithToolbar from './TableWithToolbar'

export default TableWithToolbar
